<template>
  <div class="pt-3 px-3 mb-3 light-gray-container">
    <TitleBreadCrumb
      class="return-to-school-title"
      :has-route="false"
      :page="{
        icon: titleIcon,
        title: title
      }"
    />

    <ValidationObserver ref="form" tag="div" class="row px-4 pb-4">
      <div class="col-12 pt-2">
        <div class="row">
          <div v-if="showRecommendsExisting" class="col-12 mb-2">
            <ValidationProvider
              v-slot="{ errors }"
              mode="lazy"
              rules="required"
            >
              <custom-radio-button
                v-model="model.recommendsExisting"
                class="mb-2"
                name="recommendsExistingRb"
                :label="radioTitle"
                :options="recommendsExistingOptions"
                :error="errors[0]"
                custom-error-msg="Favor seleccionar si recomienda un recurso existente."
                is-inline
                :is-disabled="readonly"
              />
            </ValidationProvider>
          </div>
          <div class="col-4">
            <div v-if="showRecommendsExisting">
             <div v-if="showRecommendsExisting && model.recommendsExisting">
              <ValidationProvider
                v-if="isTargetStatusReturnedToSchool"
                v-slot="{ errors }"
                :rules="model.recommendsExisting ? 'required' : ''"
                :custom-messages="{
                  required: 'Favor seleccionar un asistente o empleado.'
                }"
              >
                <CustomAutoComplete
                  id="assistant-search"
                  label="Seleccione un Asistente:"
                  ref="autocompleteAssistantRef"
                  placeholder="Escriba nombre del asistente o número de contrato"
                  v-model="model.currentAssistantName"
                  v-on="$listeners"
                  :debounce-time="2000"
                  :get-result-value="getResultValue"
                  display-text-name="displayName"
                  :search="searchHandler"
                  :error="errors[0]"
                  @submit="handleSubmit"
                  :disabled="readonly"
                />
              </ValidationProvider>
              <div v-if="showBadge" class="mt-1">
                <BadgeTitle
                  :key="model.assistantSelected.id"
                  :title="model.assistantSelected.displayName"
                  :has-icon="readonly"
                  @delete="deleteAssistant()"
                />
              </div>

                <ValidationProvider
                            v-if="isTargetStatusRecommended"
                            :rules="model.recommendsExisting ? 'required' : ''"
                            v-slot="{ errors }"
                            mode="lazy"
                            >
                              <label>Nombramiento de Asistente</label>
                                <custom-input
                                  label="Número de Autorización:"
                                  v-model="model.authorizationNumber"
                                  placeholder="Escriba Número de Autorización"                                  
                                  :error="errors[0]"
                                  custom-error-msg="Favor de registrar el número de autorización."
                                />
                            </ValidationProvider>   
             </div>
                
            </div>
          </div>
          <div
            :class="
              showRecommendsExisting && model.recommendsExisting
                ? 'col-8'
                : 'col-12'
            "
          >
            <ValidationProvider
              v-slot="{ errors, validate }"
              mode="lazy"
              rules="required"
              :custom-messages="{
                required: 'Favor de registrar un comentario.'
              }"
              v-if="canShowComment"
            >
              <CustomTextArea
                v-model="model.reason"
                :disabled="readonly"                
                label="Comentario:"
                regular-label
                :maxlength="3000"
                show-char-count
                :count-classes="['d-block text-right', 'small-counter']"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="validate"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div v-if="!readonly" class="col-12 pt-2 text-right">
        <ActionButton
          class="m-1"
          text="Cancelar"
          variant="outline-danger"
          i="fas fa-times-circle"
          @click="onCancel"
        />
        <ActionButton
          v-if="!readonly"
          class="m-1"
          text="Guardar"
          variant="success"
          i="fas fa-save"
          @click="onContinue"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";
import CustomRadioButton from "custom-radio";
import CustomInput from "CustomInput";
import { CustomAutoComplete } from "@/components/common";
import TitleBreadCrumb from "TitleBreadCrumb";
import { BadgeTitle } from "@/components/pei/shared";
import alert from "@/mixin/alert.mixin";

import { getServiceAssistantsList } from "@/modules/human-resources/api";
import { requestStatusCodes } from "@/utils/constants/hrrequest/requestStatusCodes";
import academicYears from "@/utils/constants/academicYears";

const initialModel = () => ({
  reason: null,
  recommendsExisting: true,
  currentAssistantName: null,
  assistantOptions: [],
  searchInput: null,
  assistantSelected: null,
  authorizationNumber: null
});

export default {
  name: "ReasonForReturn",
  mixins: [alert],
  components: {
    CustomTextArea,
    ActionButton,
    CustomInput,
    CustomRadioButton,
    CustomAutoComplete,
    TitleBreadCrumb,
    BadgeTitle
  },
  props: {
    reason: {
      type: String,
      default: null
    },
    currentStatus: {
      type: Number,
      default: 0
    },
    currentStatusTarget: {
      type: Object,
      default: () => {}
    },
    assistantSelected:{
      type: Object,
      default: () => ({})
    },
    recommendsExisting:{
      type: Boolean,
      default: () => (true)
    },
    readonly: { type: Boolean, default: false },
    title: { type: String, default: "" },
    isNotRecommended: {
      type: Boolean,
      defalt: false
    },
    academicYearId: {
      type: Number
    },
    regionId: {
      type: Number
    },
    radioTitle: {
      type: String,
      default: "¿Recomienda un recurso existente?"
    },
    radioOptionOne: {
      type: String,
      default: "Si"
    },
    radioOptionTwo: {
      type: String,
      default: "No"
    },
    persistedData:{
      type: Object,
      default: () => ({})
    },
  },
  data: () => ({ model: initialModel() }),
  watch: {
    "model.recommendsExisting": {
      handler: function(newVal) {
        if (!newVal) {
          this.model.assistantSelected = null;
        }else{
          this.$emit('reset-rempro-btn');
        }

        if(!this.reason)
          this.model.reason = null;

        this.$nextTick(() => {
          const form = this.$refs.form;
          if(form && form.reset)
            this.$refs.form.reset();
        });
      },
      deep: true
    },
    "model.assistantSelected": {
      handler: function(newVal) {
        if (newVal) {
          this.model.currentAssistantName = newVal.name;
        } else {
          this.model.currentAssistantName = null;
        }
      },
      deep: true
    },
  },
  computed: {
    titleIcon() {
      return "fas fa-exchange";
    },
    recommendsExistingOptions() {
      return [
        {
          label: this.radioOptionOne,
          value: true
        },
        {
          label: this.radioOptionTwo,
          value: false
        }
      ];
    },   
    canShowComment(){
      if(this.currentStatusTarget?.id === requestStatusCodes.recomended
       && !this.model.recommendsExisting) return false;

       return true;
    },
    showRecommendsExisting() {
      return (
        this.academicYearId >= academicYears.Y2023_2024 &&
        ((this.currentStatusTarget &&
          this.currentStatusTarget?.id ===
            requestStatusCodes.returnedToSchool) ||
          this.currentStatusTarget?.id === requestStatusCodes.recomended)
      );
    },
    isTargetStatusRecommended(){
      return this.currentStatusTarget?.id === requestStatusCodes.recomended
    },
    isTargetStatusReturnedToSchool(){
      return this.currentStatusTarget?.id === requestStatusCodes.returnedToSchool
    },
    showBadge() {
      return this.model.assistantSelected && this.model.assistantSelected?.id > 0;
    }
  },
  methods: {
    async onContinue() {
      if (this.readonly) return;
      const valid = await this.$refs["form"].validate();
      if (valid) {
        const model = {
          currentStatusTargetId: this.currentStatusTarget?.id,
          reason: this.model.reason,
          recommendsExisting: this.model.recommendsExisting,
          assistantId: this.model.assistantSelected?.assistantId,
          authNumber: this.model.authorizationNumber,
        };
        this.$emit("continue", model);
      } else {
        this.ShowToast(
          "Información Incompleta",
          "Favor de completar la información solicitada.",
          "error"
        );
      }
    },
    onCancel() {
      this.model = initialModel();
      this.$refs["form"].reset();
      this.$emit("cancel");
    },
    searchHandler(input) {
      return new Promise(resolve => {
        if (input.length < 3) {
          return resolve([]);
        }
        if (input == this.model.searchInput) {
          return resolve(this.model.assistantOptions);
        }

        this.model.searchInput = input;
        getServiceAssistantsList({
          academicYearId: this.academicYearId,
          regionId: this.regionId,
          searchInput: this.model.searchInput
        }).then(resp => {
          this.model.assistantOptions = resp.data;
          resolve(this.model.assistantOptions);
        });
      });
    },
    getResultValue(result) {
      return result.displayName;
    },
    handleSubmit(value) {
      this.model.assistantSelected = value;
    },
    deleteAssistant() {
      this.model.assistantSelected = null;
    },
    loadPersistedData(){
      if(Object.keys(this.persistedData).length === 0) return;

      if(this.persistedData.recommendsExisting === false){
      this.model.recommendsExisting = this.persistedData.recommendsExisting;
      // wait for next tick due to the watch which set the reason field to null. 
      this.$nextTick(() => {
        this.model.reason = this.persistedData.reason; 
      })
    }
    },
  },
  mounted() {
    this.model.reason = this.reason;
    this.loadPersistedData();
    if(this.assistantSelected && this.assistantSelected?.id > 0){
      this.model.assistantSelected = this.assistantSelected;
      const assitantSelected = { 
        assistantId: this.assistantSelected.id,
        displayName: this.assistantSelected.name };
      this.model.assistantSelected = assitantSelected;
      this.model.assistantOptions = this.model.assistantOptions.length > 0 ? [assitantSelected] : [];
      this.model.currentAssistantName = this.assistantSelected.name;
    }
    // by default is true, so if it's not true then set it.
    if(!this.recommendsExisting){
      this.model.recommendsExisting = this.recommendsExisting;
    }
  }
};
</script>

<style scoped>
.light-gray-container {
  background: #f7f7f7;
  border-radius: 5px;
  border-left: 6px solid #ff7058;
}

::v-deep .fas.fa-undo-alt {
  font-size: 18px;
}

::v-deep .fas.fa-flag {
  font-size: 16px;
}

::v-deep .dot {
  padding: 0 !important;
}

::v-deep .tag-badge {
  background: none !important;
}

::v-deep .tag-badge-title {
  font-size: 16px !important;
}
</style>
